export default "/images/vendor/flag-icon-css/flags/4x3/mr.svg?3642790a35ff100e55f7874d13af32c5";